export default {
  // Header
  "sd.header.badge": "Service Desk 24/7",
  "sd.header.back": "Regresar",
  "sd.header.active": "Mesa Activa 24/7",

  // Hero slides
  "sd.hero.slide1.tag": "IT Service Management",
  "sd.hero.slide1.title": "Mesa de Servicios IT",
  "sd.hero.slide1.highlight": "Clase Mundial",
  "sd.hero.slide1.subtitle": "Gestion integral de incidentes, requerimientos y cambios con procesos ITIL y SLA garantizados. Soporte 24/7 para tu operacion sin interrupciones.",
  "sd.hero.slide1.cta": "Ver servicios",

  "sd.hero.slide2.tag": "Gestion de Incidentes",
  "sd.hero.slide2.title": "Resolucion en",
  "sd.hero.slide2.highlight": "Tiempo Record",
  "sd.hero.slide2.subtitle": "Equipos de soporte multinivel L1/L2/L3 con herramientas de ticketing automatizado, base de conocimiento y escalamiento inteligente para minimizar el tiempo de inactividad.",
  "sd.hero.slide2.cta": "Ver capacidades",

  "sd.hero.slide3.tag": "Disponibilidad Garantizada",
  "sd.hero.slide3.title": "SLAs de",
  "sd.hero.slide3.highlight": "99.9% Uptime",
  "sd.hero.slide3.subtitle": "Monitoreo proactivo de infraestructura, respuesta inmediata y mejora continua con metricas en tiempo real. Tu operacion siempre disponible.",
  "sd.hero.slide3.cta": "Solicitar consultoria",

  "sd.hero.backHome": "Volver al Inicio",

  // Dashboard
  "sd.dashboard.tag": "Metricas operativas",
  "sd.dashboard.title": "Service Desk",
  "sd.dashboard.highlight": "Dashboard",
  "sd.dashboard.subtitle": "Metricas de desempeno actualizadas en tiempo real desde nuestra mesa de servicios activa 24/7",
  "sd.dashboard.teamTitle": "+200 Especialistas",
  "sd.dashboard.teamSubtitle": "Listos para ayudarte 24/7",

  "sd.dashboard.m1.label": "Tickets resueltos hoy",
  "sd.dashboard.m2.label": "SLAs cumplidos",
  "sd.dashboard.m3.label": "Agentes activos",
  "sd.dashboard.m4.label": "Tiempo de respuesta",

  // Features
  "sd.features.tag": "Servicios",
  "sd.features.title": "Capacidades del",
  "sd.features.highlight": "Service Desk",
  "sd.features.subtitle": "Una mesa de servicios IT de clase enterprise con procesos ITIL y tecnologia de punta",
  "sd.features.humanTag": "Humanizado",
  "sd.features.humanTitle": "Personas detras de la tecnologia",
  "sd.features.humanDesc": "Mas de 200 especialistas certificados trabajando para resolver tus incidentes con empatia, velocidad y excelencia.",

  "sd.features.f1.title": "Mesa de Ayuda 24/7",
  "sd.features.f1.desc": "Atencion continua multinivel L1/L2/L3 con registro, clasificacion y resolucion de tickets en tiempo real.",
  "sd.features.f1.stat": "99.9%",
  "sd.features.f1.statLabel": "SLA Garantizado",

  "sd.features.f2.title": "Gestion de Incidentes",
  "sd.features.f2.desc": "Proceso estructurado de deteccion, diagnostico y resolucion de incidentes con escalamiento automatico segun criticidad.",
  "sd.features.f2.stat": "< 15 min",
  "sd.features.f2.statLabel": "Tiempo respuesta",

  "sd.features.f3.title": "Gestion de Cambios",
  "sd.features.f3.desc": "Control de cambios ITIL con evaluacion de riesgo, planes de rollback y ventanas de mantenimiento programadas.",
  "sd.features.f3.stat": "98%",
  "sd.features.f3.statLabel": "Cambios exitosos",

  "sd.features.f4.title": "Base de Conocimiento",
  "sd.features.f4.desc": "Repositorio centralizado de soluciones, FAQs y procedimientos estandar para resolucion rapida y autonoma.",
  "sd.features.f4.stat": "5000+",
  "sd.features.f4.statLabel": "Articulos KB",

  "sd.features.f5.title": "Metricas y Reportes",
  "sd.features.f5.desc": "Dashboards en tiempo real con KPIs de servicio, tendencias de tickets y satisfaccion del usuario final.",
  "sd.features.f5.stat": "4.8/5",
  "sd.features.f5.statLabel": "CSAT Score",

  "sd.features.f6.title": "Omnicanalidad",
  "sd.features.f6.desc": "Soporte via telefono, email, chat en vivo y portal de autoservicio. Tus usuarios eligen como contactarte.",
  "sd.features.f6.stat": "5 Canales",
  "sd.features.f6.statLabel": "Disponibles",

  // CTA
  "sd.cta.tag": "Activar Service Desk",
  "sd.cta.title": "Transforma tu soporte IT con",
  "sd.cta.subtitle": "Mas de 200 especialistas IT listos para gestionar tus incidentes y mantener tu operacion siempre disponible",
  "sd.cta.button": "Solicitar consultoria gratuita",
  "sd.cta.homeButton": "Ver sitio principal",
};